module.exports = __webpack_public_path__ + "img/region-manage.4e5591a0.svg";